import { Button } from '@carbon/react';
import { FormattedCount } from 'components/formatted-count';
import type { CoverageCounts } from 'types/dps-capture';
import styles from './capture.module.scss';

interface CoverageLineProps {
  coverage: CoverageCounts;
  /** Scrolls to the preview's Unscheduled group (AC 6 — the count links to it). */
  onViewUnscheduled?: () => void;
}

/**
 * Scenario-wide coverage readout: "N of M paceable properties unscheduled". The
 * base is named (paceable inventory, never producing) and Property vocabulary is
 * used. Following the count scrolls to the preview's Unscheduled group (AC 6).
 *
 * @param {CoverageLineProps} props - The coverage counts and an optional scroll handler.
 * @return {JSX.Element} The coverage line.
 */
export function CoverageLine({
  coverage,
  onViewUnscheduled,
}: CoverageLineProps): JSX.Element {
  return (
    <div className={styles.coverageLine}>
      <span>
        <FormattedCount value={coverage.unscheduledCount} /> of{' '}
        <FormattedCount value={coverage.paceableInventoryCount} /> paceable
        properties unscheduled
      </span>
      <span className={styles.base}>(base: paceable inventory)</span>
      {onViewUnscheduled && (
        <Button kind="ghost" size="sm" onClick={onViewUnscheduled}>
          View unscheduled
        </Button>
      )}
    </div>
  );
}
